<template>
  <div>
    <div style="font-size:20px;margin: 5px">客服电话：18366628099</div>
    <el-tabs type="border-card" v-model="activeTab">
      <el-tab-pane label="私人投诉建议" name="privateChat">
        <PrivateChatMsg v-if="activeTab == 'privateChat'" ref="privateChat"></PrivateChatMsg>
        <!--      <private-chat-msg :show-private-chat="showForContent.chat&&activeChatName==='privateChat'" ref="privateChat"></private-chat-msg>-->
      </el-tab-pane>
      <el-tab-pane label="公共讨论区" name="publicChat">
        <PublicChatList ref="publicChat"></PublicChatList>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import PublicChatList from "@/pages/userCenter/ChildComps/PublicChatList";
import PrivateChatMsg from "@/pages/userCenter/ChildComps/PrivateChatMsg";

export default {
  components: {
    PublicChatList,
    PrivateChatMsg
  },
  data() {
    return {
      activeTab: "privateChat"
    }
  },
}
</script>

<style scoped>

</style>
